<template>
  <div class="animated fadeIn vld-parent custom-100" ref="test">
    <b-row class="custom-flex-1">
      <b-col sm="12" class="mt-3">
        <horizontal-stepper :steps="demoSteps" @completed-step="completeStep"
                            @active-step="isStepActive" @stepper-finished="uploadData" :can-print="isPrintable"
        >
        </horizontal-stepper>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import stepper from '../stepper/HorizontalStepper'
import step1 from './step_1_modified.vue'
import step2 from '../create/task_step2'
import step4 from '../create/task_step4'
import stepPlanTask from './plan_modified.vue'
import {arrayContains, Redirect_500, Redirect_Login, Server_URL} from "../../../shared/utils";
import {arrayBufferToBase64, encryptAES, encryptFile, encryptTodos} from "../../../shared/crypto";

export default {
  name: "CreateSeriesStepper",
  components: {
    'horizontal-stepper': stepper,
  },
  created() {
    this.isBauhof = true;
  },
  computed: {
    isPrintable() {
      return false;
    }
  },
  data() {
    return {
      isBauhof: false,
      isAndroid: false,
      hasAufgabenFromMe: false,
      canPrint: false,
      doPrint: false,
      recipient: "",
      isResend: false,
      loader: undefined,
      hasSendInternal: false,
      hasTaskManagement: false,
      payload_step2: {
        settings: {},
        selectedGroup: {}
      },
      payload_step3: {
        isExtern: false,
        hh: "",
        konto_external: '',
        hhs: ["", "", ""],
      },
      payload_step4: {
        wo: "",
        was: "",
        besch: "",
        when: ""
      },
      payload_step_select_recipient: {
        selected_recipient:""
      },
      payload_step_a_geber: {
        selectedGroup: {},
        selected_aufisn: {},
      },

      data_step1: {},
      data_step2: {
        hh: "",
        isExtern: false,
        selected: [],
      },
      data_step3: {
        hh: "",
        konto_external: "",
        external: "",
      },
      data_step4: {
        was: "",
        wo: "",
        wann: "",
        beschreibung: "",
        is_internal: false,
        recipient: "Bauhof"
      },
      data_step_plan_task: {
        legrs: [],
        kostMigrs: [],
        users: [],
      },

      files: [],
      data_id: "",
      demoSteps: [
        {
          icon: 'map',
          name: '2',
          title: 'Auftrag: Wo?',
          component: step2,
          completed: false,
          payload: {}
        },
        {
          icon: 'assignment',
          name: '1',
          title: 'Auftrag: Was?',
          component: step1,
          completed: false,
          payload: {}
        },
        {
          icon: 'event_available',
          name: 'plan_task',
          title: 'Planung',
          component: stepPlanTask,
          completed: false,
          payload: {}
        },
        {
          icon: 'assignment_turned_in',
          name: '4',
          title: 'Fertigstellen',
          component: step4,
          completed: false,
          payload: {}
        },
      ],
    }
  },
  methods: {
    showLoader() {
      this.loader = this.$loading.show();
    },
    hideLoader() {
      if (this.loader !== undefined) {
        this.loader.hide();
        this.loader = undefined;
      }
    },
    // Executed when @completed-step event is triggered
    completeStep(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.name === "1") {
            this.data_step1 = payload.returnData;
            this.setPayload({
              settings: this.data_step1.settings,
              selected_group: this.data_step1.selected_group,
            }, "2")

            if (this.isAndroid || this.isBauhof) {
              this.data_step4.was = this.data_step1.betreff;
              this.data_step4.wo = this.data_step2.selected_aufisn.gi_match;
              this.data_step4.wann = this.data_step1.date === null ? "" : this.dateToString(this.data_step1.date.toString());
              this.data_step4.beschreibung = this.data_step1.beschreibung;
              this.data_step4.anlagen = this.data_step1.anlagen;
              this.data_step4.message_files = this.data_step1.message_files;
              this.data_step4.data_id = this.dataId;
              this.data_step4.is_internal = false;
              this.data_step4.recipient = "Bauhof";
              this.recipient = "Bauhof";
              if (this.data_step1.canAccept) {
                this.setPayload({
                  legrs: this.data_step1.legrs,
                  bhStructure: this.data_step1.bhStructure,
                  canPlan: this.data_step1.canPlan,
                  dueDate: this.data_step1.date,
                  taskMemo: this.data_step1.beschreibung,
                  taskSubject: this.data_step1.betreff,
                }, "plan_task")
              }
              this.setPayload(this.data_step4, "4")
            }

            //this.demoSteps[0].title = this.data_step1.betreff;
          } else if (step.name === "2")  {
            this.data_step2 = payload.returnData;
            this.data_step2.settings = this.data_step1.settings;
            this.data_step2.isBauhof = this.isBauhof;
          } else if (step.name === "plan_task") {
            this.data_step_plan_task = payload.returnData;
            this.data_step_plan_task.acceptTask = 'Aufgabe'
            this.data_step1.date = this.data_step_plan_task.dueDate;
            this.data_step4.wann = this.data_step1.date === null ? "" : this.dateToString(this.data_step1.date.toString());
            this.setPayload(this.data_step4, "4");
          }
        }
      });
    },

    setPayload(payload, stepName) {
      for (let i = 0; i < this.demoSteps.length; i++) {
        if (this.demoSteps[i].name === stepName) {
          this.demoSteps[i].payload = payload;
          break;
        }
      }
    },
    // Executed when @active-step event is triggered
    isStepActive(payload) {
      this.demoSteps.forEach((step) => {
        if (step.name === payload.name) {
          if (step.completed === true) {
            //step.completed = false;
          }
        }
      })
    },
    async uploadData(lastStep) {
      this.doPrint = lastStep.print;
      this.files = lastStep.returnData.files;
      let wo = lastStep.returnData.wo;
      let coords = {lat: 0.0, lon: 0.0};
      if (this.data_step2.lat !== null) {
        coords.lat = this.data_step2.lat;
        coords.lon = this.data_step2.lon;
      }
      let data = {};
        let invoiceData = null;
        let aGeber = null;
        if (this.data_step2.selected_augr.typ.startsWith("EX")) {
          invoiceData = this.data_step3.external;
        }
        data = {
          is_internal: this.data_step4.is_internal,
          gi_match: this.data_step2.selected_aufisn.gi_match,
          gi_memo: this.data_step1.beschreibung + (this.data_step3.konto_external !== '' ? "\nVerrechnungskonto: " + this.data_step3.konto_external : ''),
          ziel_datum: this.data_step1.date === "" ? null : this.data_step1.date,
          gi_augr: this.data_step2.selected_augr.key,
          gi_aufisn: this.data_step2.selected_aufisn.gi_aufisn,
          gi_haus: this.data_step3.hh,
          external_konto: this.data_step3.konto_external,
          gi_auf_ext: this.data_step1.betreff,
          dringlich: this.data_step1.dringlich,
          aufgabe: this.data_step1.typ,
          group_name: this.data_step1.abteilung,
          group_id: this.data_step1.selected_group.id,
          gi_memo_plain: this.data_step1.beschreibung,
          coords: coords,
          invoice_data: invoiceData,
          a_geber_data: aGeber,
        };

      if (this.files.length !== 0 || (this.data_step1.message_files && this.data_step1.message_files.length) || (this.dataId !== "" && this.data_step1.anlagen !== "")) {
        data.has_files = true;
      }

      if(!this.data_step4.is_internal && this.data_step1.canAccept && this.data_step_plan_task.acceptTask) {

        data.accept_task = this.data_step_plan_task.acceptTask;
        data.selected_kost = this.data_step_plan_task.selected_kost_migr.id;
        data.selected_legr = this.data_step_plan_task.selected_legr.gischl;
        data.todos = this.data_step_plan_task.todos;
        data.close_automatic = this.data_step_plan_task.close_automatic;
      }
      if (sessionStorage.getItem("aes") !== null) {
        this.showLoader();
        if (data.invoice_data) {
          try {
            data.invoice_data.re_vorname = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_vorname);
            data.invoice_data.re_name1 = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_name1);
            data.invoice_data.re_str_hnr = await encryptAES(sessionStorage.getItem("aes"), data.invoice_data.re_str_hnr);
          } catch (e) {
            console.log(e)
          }
        }
        if (data.a_geber_data) {
          try {
            data.a_geber_data.gi_name1 = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_name1);
            data.a_geber_data.gi_name2 = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_name2);
            data.a_geber_data.gi_strasse = await encryptAES(sessionStorage.getItem("aes"), data.a_geber_data.gi_strasse);
          } catch (e) {
            console.log(e)
          }
        }
        encryptAES(sessionStorage.getItem("aes"), data.gi_memo).then(res => {
          data.gi_memo = res;
          if (this.hasDataId) {
            data.key = sessionStorage.getItem("aes");
          }
          if (data.todos && data.todos.length) {
            data.key = sessionStorage.getItem("aes");
            encryptTodos(sessionStorage.getItem("aes"), data.todos).then(res => {
              data.todos = res;
              this.startUpload(data)
            }).catch(res => {
              console.log(res)
            })
          } else {
            this.startUpload(data);
          }
        }).catch(res => {
          console.log(res);
        })
      } else {
        this.showLoader();
        this.startUpload(data)
      }
    },
    startUpload(payload) {
      let additionData = {};
      if (this.$route.query.message_payload !== undefined) {
        let messagePayloadId = this.$route.query.message_payload;
        let payload = JSON.parse(sessionStorage.getItem(messagePayloadId));
        sessionStorage.removeItem(messagePayloadId);
        additionData.room_id = payload.roomId;
        additionData.messages = payload.messages;
      }

      this.$http.post(
          Server_URL+'/auftragsbuch/data/create' + (this.hasDataId ? "?data_id=" + this.dataId : ""),
          payload, {params: additionData}
      ).then(this.responseOk, this.responseError)
    },
    responseUploadOk(response) {
      if (this.files.length === 0 && (this.data_step_plan_task.task_series === null || this.data_step_plan_task.task_series === undefined)) {
        this.hideLoader();
      }
      if (response.status === 200 && response.body.status === "ok") {
        if (this.files.length === 0 && (this.data_step_plan_task.task_series === null || this.data_step_plan_task.task_series === undefined)) {
          if (this.isAndroid) {
            Android.onUploadOk();
            return;
          }
          if (this.doPrint) {
            if (navigator.userAgent.startsWith("Windows - BisOffice")) {
              this.$http.get(Server_URL + '/auftragsbuch/data/pdf/' + this.data_id, {responseType: 'blob'}).then(response => {
                return response.blob();
              }).then(blob => {
                try {
                  windowsFileService.onFile(
                      blob.toBase64(),
                      this.data_id+".pdf",
                      'application/pdf',
                  ).then(r => {
                    if (r && !r.Success) {
                      console.log(r)
                    }
                  }).catch(e => {
                    console.log(e)
                  });
                } catch (e) {
                  console.log(e);
                }
              });
            } else {
              window.open(Server_URL + '/auftragsbuch/data/pdf/' + this.data_id, "_blank");
            }
          }
          if ((navigator.userAgent.startsWith("Windows - BisOffice") && !navigator.userAgent.startsWith("Windows - BisOffice Portal")) || this.$route.query.is_bauhof === 'true' || this.isBauhof) {
            this.$router.go(-1);
            return;
          }
          if (!this.hasAufgabenFromMe) {
            this.$router.replace("/auftraege/alle");
          } else {
            this.$router.replace("/aufgaben_m/alle");
          }
        } else if (this.files.length !== 0) {
          this.uploadFile();
        } else {
          this.$http.post(
              Server_URL + '/auftragsbuch/task_series/'+this.data_id,
              this.data_step_plan_task.task_series).then(this.responseTaskSeriesOk, this.responseError);
        }
      } else {
        window.location = Redirect_500;
      }
    },
    responseTaskSeriesOk(response) {
      this.hideLoader();
      if (response.status === 200) {
        if (this.isAndroid) {
          Android.onUploadOk();
          return;
        }
        if (this.doPrint) {
          if (navigator.userAgent.startsWith("Windows - BisOffice")) {
            this.$http.get(Server_URL + '/auftragsbuch/data/pdf/' + this.data_id, {responseType: 'blob'}).then(response => {
              return response.blob();
            }).then(blob => {
              try {
                windowsFileService.onFile(
                    blob.toBase64(),
                    this.data_id+".pdf",
                    'application/pdf',
                ).then(r => {
                  if (r && !r.Success) {
                    console.log(r)
                  }
                }).catch(e => {
                  console.log(e)
                });
              } catch (e) {
                console.log(e);
              }
            });
          } else {
            window.open(Server_URL + '/auftragsbuch/data/pdf/' + this.data_id, "_blank");
          }
        }
        if ((navigator.userAgent.startsWith("Windows - BisOffice") && !navigator.userAgent.startsWith("Windows - BisOffice Portal")) || this.$route.query.is_bauhof === 'true' || this.isBauhof) {
          this.$router.go(-1);
          return;
        }
        if (!this.hasAufgabenFromMe) {
          this.$router.replace("/auftraege/alle");
        } else {
          this.$router.replace("/aufgaben_m/alle");
        }
      } else {
        window.location = Redirect_500;
      }
    },
    /*
    if (this.data_step_plan_task.task_series !== null && this.data_step_plan_task.task_series !== undefined) {
              data.task_series = this.data_step_plan_task.task_series;
            }
     */
    responseOk(response) {
      if (this.files.length === 0 && (this.data_step_plan_task.task_series === null || this.data_step_plan_task.task_series === undefined)) {
        this.hideLoader();
      }
      if (response.status === 200 && response.body.status === "ok") {
        this.data_id = response.body.data.id;
        if (this.files.length === 0 && (this.data_step_plan_task.task_series === null || this.data_step_plan_task.task_series === undefined)) {
          if (this.isAndroid) {
            Android.onUploadOk();
            return;
          }
          if (this.doPrint) {
            if (navigator.userAgent.startsWith("Windows - BisOffice")) {
              this.$http.get(Server_URL + '/auftragsbuch/data/pdf/' + this.data_id, {responseType: 'blob'}).then(response => {
                return response.blob();
              }).then(blob => {
                try {
                  windowsFileService.onFile(
                      blob.toBase64(),
                      this.data_id+".pdf",
                      'application/pdf',
                  ).then(r => {
                    if (r && !r.Success) {
                      console.log(r)
                    }
                  }).catch(e => {
                    console.log(e)
                  });
                } catch (e) {
                  console.log(e);
                }
              });
            } else {
              window.open(Server_URL + '/auftragsbuch/data/pdf/' + this.data_id, "_blank");
            }
          }
          if ((navigator.userAgent.startsWith("Windows - BisOffice") && !navigator.userAgent.startsWith("Windows - BisOffice Portal")) || this.$route.query.is_bauhof === 'true' || this.isBauhof) {
            this.$router.go(-1);
            return;
          }
          if (!this.hasAufgabenFromMe) {
            this.$router.replace("/auftraege/alle");
          } else {
            this.$router.replace("/aufgaben_m/alle");
          }
        } else if (this.files.length !== 0) {
          this.uploadFile();
        } else {
          this.$http.post(
              Server_URL + '/auftragsbuch/task_series/'+this.data_id,
              this.data_step_plan_task.task_series).then(this.responseTaskSeriesOk, this.responseError);
        }
      } else {
        window.location = Redirect_500;
      }
    },
    uploadFile() {
      if (this.files.length !== 0) {
        let file = this.files.pop();
        if (sessionStorage.getItem("aes") !== null) {
          const reader = new FileReader();
          reader.addEventListener('load', (event) => {
            let buf = new Uint8Array(event.target.result);
            encryptFile(sessionStorage.getItem("aes"), buf).then(res => {
              const b = new Blob([res], {type: file.type});
              let formData = new FormData();
              formData.append('upload_file', b, file.name);
              formData.append('key', sessionStorage.getItem("aes"))
              this.$http.post(Server_URL + '/auftragsbuch/upload/file/'
                  + this.data_id + "?file_type=A",
                  formData,
                  {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    }
                  }
              ).then(this.responseUploadOk, this.responseError)
            }).catch(err => {
              console.log(err);
              this.hideLoader();
            })
          });
          reader.readAsArrayBuffer(file);
        } else {
          let formData = new FormData();
          formData.append('upload_file', file);
          this.$http.post(Server_URL + '/auftragsbuch/upload/file/'
              + this.data_id + "?file_type=A",
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data'
                }
              }
          ).then(this.responseUploadOk, this.responseError)
        }
      }
    },
    responseError(response) {
      this.hideLoader();
      if (response.status === 401) {
        window.location = Redirect_Login;
      } else {
        window.location = Redirect_500;
      }
    },
    dateToString(value) {
      if (value === null || value === "") {
        return "---"
      }
      let event = new Date(value.replace('Z',''));
      let options = { year: 'numeric', month: '2-digit', day: '2-digit' };
      return event.toLocaleDateString('de-DE', options);
    },
  },
}
</script>

<style scoped>


.row {
  flex: initial;
  margin: unset;
  margin-right: -15px;
  margin-left: -15px;
}

.col-xl, .col-xl-auto, .col-xl-12, .col-xl-11, .col-xl-10, .col-xl-9, .col-xl-8, .col-xl-7, .col-xl-6, .col-xl-5, .col-xl-4, .col-xl-3, .col-xl-2, .col-xl-1, .col-lg, .col-lg-auto, .col-lg-12, .col-lg-11, .col-lg-10, .col-lg-9, .col-lg-8, .col-lg-7, .col-lg-6, .col-lg-5, .col-lg-4, .col-lg-3, .col-lg-2, .col-lg-1, .col-md, .col-md-auto, .col-md-12, .col-md-11, .col-md-10, .col-md-9, .col-md-8, .col-md-7, .col-md-6, .col-md-5, .col-md-4, .col-md-3, .col-md-2, .col-md-1, .col-sm, .col-sm-auto, .col-sm-12, .col-sm-11, .col-sm-10, .col-sm-9, .col-sm-8, .col-sm-7, .col-sm-6, .col-sm-5, .col-sm-4, .col-sm-3, .col-sm-2, .col-sm-1, .col, .col-auto, .col-12, .col-11, .col-10, .col-9, .col-8, .col-7, .col-6, .col-5, .col-4, .col-3, .col-2, .col-1 {
  width: 100%;
  padding: unset;
  padding-right: 15px;
  padding-left: 15px;
}

.row + .row {
  margin-top: unset;
}

</style>
